import { produce } from "immer";
import {
  FETCH_ASSIGNED_ROOMS,
  FETCH_ASSIGNED_ROOMS_SUCCESS,
  FETCH_ASSIGNED_ROOMS_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_ASSIGNED_ROOM,
  ADD_ASSIGNED_ROOM_SUCCESS,
  ADD_ASSIGNED_ROOM_FAILURE,
  //
  EDIT_ASSIGNED_ROOM,
  EDIT_ASSIGNED_ROOM_SUCCESS,
  EDIT_ASSIGNED_ROOM_FAILURE,
  //
  DELETE_ASSIGNED_ROOMS,
  DELETE_ASSIGNED_ROOMS_SUCCESS,
  DELETE_ASSIGNED_ROOMS_FAILURE,
  //
  OPEN_ASSIGNED_ROOMS_MODAL,
  CLOSE_ASSIGNED_ROOMS_MODAL,
} from "./constants";

export const initialState = {
  isFetchingRoom: false,
  roomsList: [],
  //
  isFetching: false,
  currentRoom: {},
  //
  isSubmitting: false,
  isDeleting: false,
  //
  isRoomModalOpen: {
    open: false,
    mode: "",
    residentId: null,
    locationId: null,
    currentRoom: null,
  },
};

const RoomReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_ASSIGNED_ROOMS:
        draft.isFetchingRoom = true;
        break;
      case FETCH_ASSIGNED_ROOMS_SUCCESS:
        draft.isFetchingRoom = false;
        draft.roomsList = action.payload;
        break;
      case FETCH_ASSIGNED_ROOMS_FAILURE:
        draft.isFetchingRoom = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentRoom = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentRoom = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_ASSIGNED_ROOM:
        draft.isSubmitting = true;
        break;
      case ADD_ASSIGNED_ROOM_SUCCESS:
        draft.isSubmitting = false;
        draft.isRoomModalOpen = {
          open: false,
          mode: "",
          residentId: null,
          locationId: null,
          currentRoom: null,
        };
        break;
      case ADD_ASSIGNED_ROOM_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_ASSIGNED_ROOM:
        draft.isSubmitting = true;
        break;
      case EDIT_ASSIGNED_ROOM_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_ASSIGNED_ROOM_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_ASSIGNED_ROOMS:
        draft.isDeleting = true;
        break;
      case DELETE_ASSIGNED_ROOMS_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_ASSIGNED_ROOMS_FAILURE:
        draft.isDeleting = false;
        break;
      //
      case OPEN_ASSIGNED_ROOMS_MODAL:
        draft.isRoomModalOpen = {
          open: true,
          mode: action.payload?.mode ?? "assign",
          residentId:
            action.payload?.residentId ?? action.payload?.resident_id ?? null,
          locationId:
            action.payload?.locationId ?? action.payload?.location_id ?? null,
          ...action.payload,
        };
        break;
      case CLOSE_ASSIGNED_ROOMS_MODAL:
        draft.isRoomModalOpen = {
          open: false,
          mode: "",
          residentId: null,
          locationId: null,
          currentRoom: null,
        };
        break;

      default:
        return state;
    }
  });

export default RoomReducer;
